import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useEditorStore } from '../../store/editorStore';

export default function ShapeProperties({ layer }) {
  const data = layer.data;
  const updateLayerData = useEditorStore((s) => s.updateLayerData);
  const [colorOpen, setColorOpen] = useState(false);
  const [strokeOpen, setStrokeOpen] = useState(false);

  function update(updates) {
    updateLayerData(layer.id, updates);
  }

  return (
    <div className="p-2 space-y-3">
      <p className="panel-label">Shape</p>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Shape Type</label>
        <select
          value={data.shape}
          onChange={(e) => update({ shape: e.target.value })}
          className="input-field text-xs"
        >
          {['rectangle', 'circle', 'triangle', 'star', 'heart', 'line'].map((s) => (
            <option key={s} value={s} className="capitalize">{s}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="text-xs block mb-1" style={{ color: 'var(--t-muted)' }}>Fill Color</label>
        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded cursor-pointer"
            style={{ border: '1px solid var(--t-border2)', background: data.fill }}
            onClick={() => setColorOpen(!colorOpen)}
          />
          <input
            type="text" value={data.fill}
            onChange={(e) => update({ fill: e.target.value })}
            className="input-field text-xs py-1 font-mono flex-1"
          />
        </div>
        {colorOpen && (
          <div className="mt-2">
            <HexColorPicker color={data.fill} onChange={(c) => update({ fill: c })} style={{ width: '100%', height: 120 }} />
          </div>
        )}
      </div>

      <div>
        <label className="text-xs block mb-1" style={{ color: 'var(--t-muted)' }}>Stroke Color</label>
        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded cursor-pointer"
            style={{ border: '1px solid var(--t-border2)', background: data.stroke || 'transparent' }}
            onClick={() => setStrokeOpen(!strokeOpen)}
          />
          <input
            type="text" value={data.stroke || ''}
            onChange={(e) => update({ stroke: e.target.value || null })}
            className="input-field text-xs py-1 font-mono flex-1"
            placeholder="none"
          />
        </div>
        {strokeOpen && (
          <div className="mt-2">
            <HexColorPicker
              color={data.stroke || '#ffffff'}
              onChange={(c) => update({ stroke: c })}
              style={{ width: '100%', height: 120 }}
            />
          </div>
        )}
      </div>

      {data.stroke && (
        <div>
          <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Stroke Width</label>
          <input
            type="number" value={data.strokeWidth}
            onChange={(e) => update({ strokeWidth: parseInt(e.target.value) || 0 })}
            min={0} max={20}
            className="input-field text-xs py-1"
          />
        </div>
      )}

      {data.shape === 'rectangle' && (
        <div>
          <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Border Radius</label>
          <input
            type="range" value={data.borderRadius || 0}
            onChange={(e) => update({ borderRadius: parseInt(e.target.value) })}
            min={0} max={100}
          />
          <span className="text-xs" style={{ color: 'var(--t-muted)' }}>{data.borderRadius || 0}px</span>
        </div>
      )}
    </div>
  );
}
